import { Icon } from 'leaflet';

export type MapProps = [longitude: number, latitude: number] | null;

export type AssetType =
  | 'TfLRedRoutesTLRNs'
  | 'Westminster1kmBoundaryBuffer'
  | 'CycleHangarsEstates'
  | 'CycleHangars'
  | 'TfLHighwayAuthorityBoundary'
  | 'WestminsterBoundary'
  | 'SmokeAndOdours'
  | 'Noise'
  | 'HighwaysCarriageways'
  | 'HighwaysFootways'
  | 'HighwaysGullies'
  | 'PublicLightingStreetlights'
  | 'PropertyGazetteer'
  | 'PublicLightingStreetlightsEnquiries'
  | 'HighwaysGulliesEnquiries'
  | 'HighwaysCarriagewaysEnquiries'
  | 'HighwaysFootwaysEnquiries'
  | 'Mask'
  | 'StreetGazetteer'
  | 'HighwaysBollards'
  | 'HighwaysBollardsEnquiries'
  | 'HighwaysKerbs'
  | 'HighwaysKerbsEnquiries'
  | 'HighwaysNameplates'
  | 'HighwaysNameplatesEnquiries'
  | 'HighwaysSigns'
  | 'HighwaysSignsEnquiries'
  | 'PublicLightingBelishaBeacons'
  | 'PublicLightingBelishaBeaconsEnquiries'
  | 'PublicLightingBollards'
  | 'PublicLightingBollardsEnquiries'
  | 'PublicLightingFeederPillars'
  | 'PublicLightingFeederPillarsEnquiries'
  | 'PublicLightingIlluminatedSigns'
  | 'PublicLightingIlluminatedSignsEnquiries'
  | 'PublicLightingWallLights'
  | 'PublicLightingWallLightsEnquiries'
  | 'HighwaysWholeSiteFeatures'
  | 'DrainageWholeSiteFeatures'
  | 'PublicLightingWholeSitefeatures'
  | 'StreetEntertainmentPitches'
  | 'StreetEntertainmentRegulatedAreas'
  | 'PublicLightingElectricVehicleChargers'
  | 'PublicLightingElectricVehicleChargersEnquiries';

export const assetTypeId: { [key in AssetType]: string } = {
  TfLRedRoutesTLRNs: '2',
  Westminster1kmBoundaryBuffer: '542',
  CycleHangarsEstates: '543',
  CycleHangars: '444',
  TfLHighwayAuthorityBoundary: '3',
  WestminsterBoundary: '4',
  SmokeAndOdours: '6',
  Noise: '7',
  HighwaysCarriageways: '11',
  HighwaysFootways: '14',
  HighwaysGullies: '16',
  PublicLightingStreetlights: '18',
  PropertyGazetteer: '25',
  PublicLightingStreetlightsEnquiries: '27',
  HighwaysGulliesEnquiries: '28',
  HighwaysCarriagewaysEnquiries: '34',
  HighwaysFootwaysEnquiries: '36',
  Mask: '38',
  StreetGazetteer: '40',
  HighwaysBollards: '42',
  HighwaysBollardsEnquiries: '43',
  HighwaysKerbs: '44',
  HighwaysKerbsEnquiries: '45',
  HighwaysNameplates: '46',
  HighwaysNameplatesEnquiries: '47',
  HighwaysSigns: '48',
  HighwaysSignsEnquiries: '49',
  PublicLightingBelishaBeacons: '50',
  PublicLightingBelishaBeaconsEnquiries: '51',
  PublicLightingBollards: '52',
  PublicLightingBollardsEnquiries: '53',
  PublicLightingFeederPillars: '56',
  PublicLightingFeederPillarsEnquiries: '57',
  PublicLightingIlluminatedSigns: '58',
  PublicLightingIlluminatedSignsEnquiries: '59',
  PublicLightingWallLights: '60',
  PublicLightingWallLightsEnquiries: '61',
  HighwaysWholeSiteFeatures: '62',
  DrainageWholeSiteFeatures: '63',
  PublicLightingWholeSitefeatures: '64',
  StreetEntertainmentPitches: '66',
  StreetEntertainmentRegulatedAreas: '67',
  PublicLightingElectricVehicleChargers: '69',
  PublicLightingElectricVehicleChargersEnquiries: '70',
};

export interface AssetConfig {
  asset: AssetType;
  icon?:
    | {
        shape?: 'circle' | 'square' | 'triangle';
        size?: number;
      }
    | Icon;
  color?: string;
  opacity?: number;
  strokeColor?: string;
}

export type AssetTypeConfig = AssetType | AssetConfig;

export interface NearestApiResponse {
  within_boundary: boolean;
  within_tfl_boundary: boolean;
  features: Feature[];
}

interface Feature {
  attributes: HighwaysCarriagewaysFeatureAttributes;
  geometry: FeatureGeometry;
}

interface FeatureGeometry {
  paths: Coordinate[][];
}

type Coordinate = [number, number];

export interface HighwaysCarriagewaysFeatureAttributes {
  site_class_code: string;
  site_class_name: string;
  central_asset_id: string;
  contract_area_code: string;
  feature_type_code: string;
  layer: AssetType;
  site_name?: string;
}

export interface CycleHangarsFeatureAttributes {
  Application_URL: string;
  Available_Spaces: number;
  CH_Ref: string;
  Data_Custodian: string;
  Eastings: number;
  Footway_Carriageway: string;
  GIS_Load_Date: number;
  GIS_Ref: number;
  Grid_Reference: string;
  Hangar_Capacity: number;
  Installation_Date: number;
  Latitude: number;
  Location: string;
  Longitude: number;
  Northings: number;
  OBJECTID: number;
  Postcode: string;
  Street_Name: string;
}

export interface CycleHangarsEstatesFeatureAttributes {
  Application_URL: string;
  Available_Spaces: number;
  Comments: string;
  Eastings: number;
  Estate_Name: string;
  Footway_Carriageway: string;
  GISLoadDate: number;
  GIS_Ref: number;
  Installation_Date: number;
  Latitude: number;
  Location: string;
  Longitude: number;
  Northings: number;
  OBJECTID: number;
  Postcode: string;
  Street_Name: string;
  Unit_ID: string;
}
